/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as OrderConfirmationRouteImport } from './routes/order-confirmation'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductIdRouteImport } from './routes/product.$id'
import { Route as ProductRouteImport } from './routes/product.'

const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopRoute = ShopRouteImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderConfirmationRoute = OrderConfirmationRouteImport.update({
  id: '/order-confirmation',
  path: '/order-confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductIdRoute = ProductIdRouteImport.update({
  id: '/product/$id',
  path: '/product/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductRoute = ProductRouteImport.update({
  id: '/product/',
  path: '/product/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/order-confirmation': typeof OrderConfirmationRoute
  '/shop': typeof ShopRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/product/': typeof ProductRoute
  '/product/$id': typeof ProductIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/order-confirmation': typeof OrderConfirmationRoute
  '/shop': typeof ShopRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/product': typeof ProductRoute
  '/product/$id': typeof ProductIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRoute
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/order-confirmation': typeof OrderConfirmationRoute
  '/shop': typeof ShopRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/product/': typeof ProductRoute
  '/product/$id': typeof ProductIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/cart'
    | '/checkout'
    | '/order-confirmation'
    | '/shop'
    | '/sitemap.xml'
    | '/product/'
    | '/product/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/admin'
    | '/cart'
    | '/checkout'
    | '/order-confirmation'
    | '/shop'
    | '/sitemap.xml'
    | '/product'
    | '/product/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/cart'
    | '/checkout'
    | '/order-confirmation'
    | '/shop'
    | '/sitemap.xml'
    | '/product/'
    | '/product/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRoute
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  OrderConfirmationRoute: typeof OrderConfirmationRoute
  ShopRoute: typeof ShopRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  ProductRoute: typeof ProductRoute
  ProductIdRoute: typeof ProductIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop': {
      id: '/shop'
      path: '/shop'
      fullPath: '/shop'
      preLoaderRoute: typeof ShopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-confirmation': {
      id: '/order-confirmation'
      path: '/order-confirmation'
      fullPath: '/order-confirmation'
      preLoaderRoute: typeof OrderConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/$id': {
      id: '/product/$id'
      path: '/product/$id'
      fullPath: '/product/$id'
      preLoaderRoute: typeof ProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/product/': {
      id: '/product/'
      path: '/product'
      fullPath: '/product/'
      preLoaderRoute: typeof ProductRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRoute,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  OrderConfirmationRoute: OrderConfirmationRoute,
  ShopRoute: ShopRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  ProductRoute: ProductRoute,
  ProductIdRoute: ProductIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
